// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/app/src/models/banks';
import model_2 from '/app/src/models/me';
import model_3 from '/app/src/models/notifications';
import model_4 from '/app/src/models/profile.model';
import model_5 from '/app/src/pages/features/affiliate/pages/affiliateList/model';
import model_6 from '/app/src/pages/features/affiliate/pages/cbuDetail/model';
import model_7 from '/app/src/pages/features/affiliate/pages/detail/details/components/actions/changeAffiliateState/model';
import model_8 from '/app/src/pages/features/affiliate/pages/detail/model';
import model_9 from '/app/src/pages/features/affiliate/pages/dniDetail/model';
import model_10 from '/app/src/pages/features/affiliate/pages/iomaDetail/model';
import model_11 from '/app/src/pages/features/affiliate/pages/new/model';
import model_12 from '/app/src/pages/features/affiliate/pages/paycheckDetail/model';
import model_13 from '/app/src/pages/features/affiliate/pages/settings/model';
import model_14 from '/app/src/pages/features/affiliate/pages/stats/model';
import model_15 from '/app/src/pages/features/affiliate/pages/studentCredential/model';
import model_16 from '/app/src/pages/features/allowances/pages/allowanceDetail/model';
import model_17 from '/app/src/pages/features/allowances/pages/allowancesList/model';
import model_18 from '/app/src/pages/features/consumptions/pages/stats/model';
import model_19 from '/app/src/pages/features/contact-us/pages/delegationsList/model';
import model_20 from '/app/src/pages/features/fileboxes/pages/filebox/model';
import model_21 from '/app/src/pages/features/files/pages/dashboardAnalysis/model';
import model_22 from '/app/src/pages/features/files/pages/detail/components/changeFileState/model';
import model_23 from '/app/src/pages/features/files/pages/detail/model';
import model_24 from '/app/src/pages/features/files/pages/filesList/model';
import model_25 from '/app/src/pages/features/files/pages/inboxDetail/model';
import model_26 from '/app/src/pages/features/imports/pages/affiliates_cadets/model';
import model_27 from '/app/src/pages/features/imports/pages/affiliates/model';
import model_28 from '/app/src/pages/features/imports/pages/biochemicalVoucher/model';
import model_29 from '/app/src/pages/features/imports/pages/biochemicalVoucherDetails/model';
import model_30 from '/app/src/pages/features/imports/pages/cbu/model';
import model_31 from '/app/src/pages/features/imports/pages/consumptions/model';
import model_32 from '/app/src/pages/features/imports/pages/products/model';
import model_33 from '/app/src/pages/features/loans/pages/detail/model';
import model_34 from '/app/src/pages/features/loans/pages/liquidation/model';
import model_35 from '/app/src/pages/features/loans/pages/loans/model';
import model_36 from '/app/src/pages/features/loans/pages/mine/model';
import model_37 from '/app/src/pages/features/loans/pages/new/model';
import model_38 from '/app/src/pages/features/partialPayments/pages/partialPaymentRequestCreate/model';
import model_39 from '/app/src/pages/features/payments/pages/account/model';
import model_40 from '/app/src/pages/features/payments/pages/liquidation/model';
import model_41 from '/app/src/pages/features/providerFiles/pages/detail/model';
import model_42 from '/app/src/pages/features/providerFiles/pages/list/model';
import model_43 from '/app/src/pages/features/providerFiles/pages/new/model';
import model_44 from '/app/src/pages/features/providers/pages/providersList/model';
import model_45 from '/app/src/pages/features/representants/pages/detail/model';
import model_46 from '/app/src/pages/features/representants/pages/list/model';
import model_47 from '/app/src/pages/features/representants/pages/new/model';
import model_48 from '/app/src/pages/features/tramits/pages/new-tramit/model';
import model_49 from '/app/src/pages/features/tramits/pages/pendingTramits/model';
import model_50 from '/app/src/pages/features/tramits/pages/tramitDetails/model';
import model_51 from '/app/src/pages/features/tramits/pages/tramitList/model';
import model_52 from '/app/src/pages/features/user/settings/model';

export const models = {
model_1: { namespace: 'banks', model: model_1 },
model_2: { namespace: 'me', model: model_2 },
model_3: { namespace: 'notifications', model: model_3 },
model_4: { namespace: 'profile', model: model_4 },
model_5: { namespace: 'features.affiliate.affiliateList.model', model: model_5 },
model_6: { namespace: 'features.affiliate.cbuDetail.model', model: model_6 },
model_7: { namespace: 'features.affiliate.detail.details.components.actions.changeAffiliateState.model', model: model_7 },
model_8: { namespace: 'features.affiliate.detail.model', model: model_8 },
model_9: { namespace: 'features.affiliate.dniDetail.model', model: model_9 },
model_10: { namespace: 'features.affiliate.iomaDetail.model', model: model_10 },
model_11: { namespace: 'features.affiliate.new.model', model: model_11 },
model_12: { namespace: 'features.affiliate.paycheckDetail.model', model: model_12 },
model_13: { namespace: 'features.affiliate.settings.model', model: model_13 },
model_14: { namespace: 'features.affiliate.stats.model', model: model_14 },
model_15: { namespace: 'features.affiliate.studentCredential.model', model: model_15 },
model_16: { namespace: 'features.allowances.allowanceDetail.model', model: model_16 },
model_17: { namespace: 'features.allowances.allowancesList.model', model: model_17 },
model_18: { namespace: 'features.consumptions.stats.model', model: model_18 },
model_19: { namespace: 'features.contact-us.delegationsList.model', model: model_19 },
model_20: { namespace: 'features.fileboxes.filebox.model', model: model_20 },
model_21: { namespace: 'features.files.dashboardAnalysis.model', model: model_21 },
model_22: { namespace: 'features.files.detail.components.changeFileState.model', model: model_22 },
model_23: { namespace: 'features.files.detail.model', model: model_23 },
model_24: { namespace: 'features.files.filesList.model', model: model_24 },
model_25: { namespace: 'features.files.inboxDetail.model', model: model_25 },
model_26: { namespace: 'features.imports.affiliates_cadets.model', model: model_26 },
model_27: { namespace: 'features.imports.affiliates.model', model: model_27 },
model_28: { namespace: 'features.imports.biochemicalVoucher.model', model: model_28 },
model_29: { namespace: 'features.imports.biochemicalVoucherDetails.model', model: model_29 },
model_30: { namespace: 'features.imports.cbu.model', model: model_30 },
model_31: { namespace: 'features.imports.consumptions.model', model: model_31 },
model_32: { namespace: 'features.imports.products.model', model: model_32 },
model_33: { namespace: 'features.loans.detail.model', model: model_33 },
model_34: { namespace: 'features.loans.liquidation.model', model: model_34 },
model_35: { namespace: 'features.loans.loans.model', model: model_35 },
model_36: { namespace: 'features.loans.mine.model', model: model_36 },
model_37: { namespace: 'features.loans.new.model', model: model_37 },
model_38: { namespace: 'features.partialPayments.partialPaymentRequestCreate.model', model: model_38 },
model_39: { namespace: 'features.payments.account.model', model: model_39 },
model_40: { namespace: 'features.payments.liquidation.model', model: model_40 },
model_41: { namespace: 'features.providerFiles.detail.model', model: model_41 },
model_42: { namespace: 'features.providerFiles.list.model', model: model_42 },
model_43: { namespace: 'features.providerFiles.new.model', model: model_43 },
model_44: { namespace: 'features.providers.providersList.model', model: model_44 },
model_45: { namespace: 'features.representants.detail.model', model: model_45 },
model_46: { namespace: 'features.representants.list.model', model: model_46 },
model_47: { namespace: 'features.representants.new.model', model: model_47 },
model_48: { namespace: 'features.tramits.new-tramit.model', model: model_48 },
model_49: { namespace: 'features.tramits.pendingTramits.model', model: model_49 },
model_50: { namespace: 'features.tramits.tramitDetails.model', model: model_50 },
model_51: { namespace: 'features.tramits.tramitList.model', model: model_51 },
model_52: { namespace: 'features.user.settings.model', model: model_52 },
} as const
